import React from "react";

export const LengendColumns = ({tipoPromocion, toolTips, setFechasCambiar, setTipoBotonPromotion}) => {
  console.log("Tooltips::::: ")
  console.log(toolTips)
  return (
    <div className="LengendColumns">
      <p className="heading-column">Product</p>
      <button className="button-box">
        Code
        <div className="tooltip">
          <h1>Code</h1>
          <p>
            {toolTips && toolTips.codigo}
          </p>
        </div>
      </button>
      <button className="button-box">
        Description
        <div className="tooltip">
          <h1>Description</h1>
          <p>
            {toolTips && toolTips.descripcion}
          </p>
        </div>
      </button>
      <button className="button-box">
       List Price
        <div className="tooltip">
          <h1>List Price</h1>
          <p>
            {toolTips && toolTips.precio_lista}
          </p>
        </div>
      </button>
      <p className="heading-column">Promotion</p>
      
      <button className="button-box">
        { tipoPromocion && tipoPromocion==='SELL-IN' ? "Promotional Price" : "Strapping PSP"}
        <div className="tooltip">
          <h1>{tipoPromocion && tipoPromocion==='SELL-IN' ? "Promotional Price" : "Strapping Price"}</h1>
          <p>
            {toolTips && toolTips.precio_promocion}
          </p>
        </div>
      </button>
      <button className="button-box">
        % Discount
        <div className="tooltip">
          <h1>% Discount</h1>
          <p>
            {toolTips && toolTips.porcentaje_descuento}
          </p>
        </div>
      </button>
      <p className="heading-column">Promotional Variables</p>
      <button className="button-box">
      Mechanics
        <div className="tooltip">
          <h1>Mechanics</h1>
          <p>
            {toolTips && toolTips.mecanica}
          </p>
        </div>
      </button>
      <button className="button-box">
      Effectiveness
        <div className="tooltip">
          <h1>Effectiveness</h1>
          <p>
            {toolTips && toolTips.adherencia}
          </p>
        </div>
      </button>
      <button className="button-box">
      Exhibition
        <div className="tooltip">
          <h1>Exhibition</h1>
          <p>
            {toolTips && toolTips.exhibicion}
          </p>
        </div>
      </button>
      <button className="button-box">
        Activation
        <div className="tooltip">
          <h1>Activation</h1>
          <p>
            {toolTips && toolTips.activacion}
          </p>
        </div>
      </button>
      <button className="button-box">
      Investment
        <div className="tooltip">
          <h1>Investment</h1>
          <p>
            {toolTips && toolTips.inv_adicional}
          </p>
        </div>
      </button>
      <p className="heading-column">RRP</p>
      <button className="button-box">
        Customer Margin
        <div className="tooltip">
          <h1>Customer Margin</h1>
          <p>
            {toolTips && toolTips.margen_cliente}
          </p>
        </div>
      </button>
      <button className="button-box">
      { tipoPromocion && tipoPromocion==='SELL-IN' ? "Promotional RRP" : "Promotional RRP"}
        <div className="tooltip">
          <h1>{ tipoPromocion && tipoPromocion==='SELL-IN' ? "Promotional RRP" : "Promotional RRP"}</h1>
          <p>
            {toolTips && toolTips.pvp}
          </p>
        </div>
      </button>
      <p className="heading-column">Dates</p>
      {(tipoPromocion && tipoPromocion==='SELL-IN') &&
      <button className="button-box" 
        onClick={() => {
          setTipoBotonPromotion("sell_in")
          setFechasCambiar(true)          
        }}
      >
        Sell-In
        <div className="tooltip">
          <h1> Sell-In</h1>
          <p>
            {toolTips && toolTips.sell_in}
          </p>
        </div>
      </button>
      }
      <button className="button-box"
        onClick={() => {
          setTipoBotonPromotion("sell_out")
          setFechasCambiar(true)
          }
        }
      >
        Sell-Out
        <div className="tooltip">
          <h1>Sell-Out</h1>
          <p>
            {toolTips && toolTips.sell_out}
          </p>
        </div>
      </button>
    </div>
  );
};
